import React, { useState } from 'react';
import '../css/ApiKeyDisplay.css';

function ApiKeyDisplay({ apiKey, labelAlias, onClose }) {
    const [copied, setCopied] = useState(false);
    const [slackCopied, setSlackCopied] = useState(false);

    const slackMessage = `A new label has been added for scm-ui, please update labels.json file with ${labelAlias}, https://ghe.coxautoinc.com/DDC-WebPlatform/scm-ui/blob/master/src/label-aliases.js`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(apiKey);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const handleSlackCopy = async () => {
        try {
            await navigator.clipboard.writeText(slackMessage);
            setSlackCopied(true);
            setTimeout(() => setSlackCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className="api-key-display">
            <button
                onClick={onClose}
                className="close-button"
                aria-label="Close"
            >
                ×
            </button>
            <h3>API Key Generated Successfully!</h3>
            <div className="api-key-container">
                <input
                    type="text"
                    value={apiKey}
                    readOnly
                    className="api-key-input"
                />
                <button
                    onClick={handleCopy}
                    className={`copy-button ${copied ? 'copied' : ''}`}
                >
                    {copied ? 'Copied!' : 'Copy'}
                </button>
            </div>
            <p className="warning-text">
                ⚠️ Save this API key now. You won't be able to see it again!
            </p>
            <div className="slack-message-box">
                <p className="slack-message-label">Send this in <strong>#ddc-dsf-boba-support</strong> on Slack:</p>
                <div className="api-key-container">
                    <input
                        type="text"
                        value={slackMessage}
                        readOnly
                        className="api-key-input"
                    />
                    <button
                        onClick={handleSlackCopy}
                        className={`copy-button ${slackCopied ? 'copied' : ''}`}
                    >
                        {slackCopied ? 'Copied!' : 'Copy'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ApiKeyDisplay;
